import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CtaLink } from "@/src/common/components/cta-link";
import { EyebrowBadge } from "@/src/common/components/eyebrow-badge";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { SectionHeading } from "@/src/common/components/section-heading";
import { SITE_ROUTES } from "@/src/common/constants/site-routes";

export function NotFoundPage() {
	const { t } = useTranslation("common");

	return (
		<>
			<PageHelmet title={t("not_found.meta_title")} noindex />

			<section className="bg-mesh relative isolate overflow-hidden pt-24 pb-32 md:pt-36 md:pb-40">
				<div className="mx-auto flex max-w-3xl flex-col items-center gap-10 px-4 text-center sm:px-6 lg:px-8">
					<SectionHeading
						as="h1"
						animated={false}
						eyebrow={<EyebrowBadge tone="ink">{t("not_found.eyebrow")}</EyebrowBadge>}
						title={t("not_found.title")}
						description={t("not_found.body")}
					/>
					<CtaLink to={SITE_ROUTES.HOME} variant="gradient" size="lg" startContent={<ArrowLeft className="h-4 w-4" />}>
						{t("not_found.back_home")}
					</CtaLink>
				</div>
			</section>
		</>
	);
}
